export const DocumentPreview = ({ signedUrl }) => {
  return (
    <iframe
      src={signedUrl}
      title="Document Preview"
      width="100%"
      height="100%"
      style={{ border: "none" }}
    />
  );
};
